import { z } from "zod";
import { storageQuotaBytesSchema } from "./system-config-contracts.js";
/**
 * Customer usage for one organization. Null limits mean Unlimited.
 * Storage bytes are decimal strings. Legacy Organization.storageQuotaBytes is not included.
 */
export const organizationUsageResponseSchema = z.object({
    contacts: z.object({
        used: z.number().int().nonnegative(),
        reserved: z.number().int().nonnegative(),
        limit: z.number().int().nonnegative().nullable(),
        available: z.number().int().nonnegative().nullable(),
    }),
    team: z.object({
        occupied: z.number().int().nonnegative(),
        members: z.number().int().nonnegative(),
        pendingInvitations: z.number().int().nonnegative(),
        limit: z.number().int().min(1).nullable(),
    }),
    storage: z.object({
        usedBytes: storageQuotaBytesSchema,
        limitBytes: storageQuotaBytesSchema.nullable(),
    }),
});
//# sourceMappingURL=organization-usage-contracts.js.map